import { LegendContainer, StyledLegendButton } from "./LegendStyle";
import { impactLevelInfo, pagesToShow } from "../../../app/riskLevel";
import { Button, Dialog, DialogActions, DialogContent, Tooltip } from "@mui/material";
import RiskLevelStepper from "../../sidebar/RiskLevelStepper";
import React, { useState } from "react";
import { AllowedImpactLevel, CLOSE } from "../../UserVisibleStrings";
import { useIsRightBarExpanded } from "../../../features/Drawer/drawerSlice";
import ImpactIcon from "../ImpactIcon";
import { useShouldShowAlerts } from "../../../features/alertDisplay/alertDisplaySlice";

export type LegendProps = {
    isMobile: boolean,
};

/**
 * Legend component displays risk levels and provides interactions.
 * @param {LegendProps} props - The properties object.
 * @returns {JSX.Element} The rendered Legend component.
 */
export const Legend: React.FC<LegendProps> = ( { isMobile } ) =>
{
    const [ openRiskDetails, setOpenRiskDetails ] = useState( false );
    const [ riskLevelDetail, setRiskLevelDetail ] = useState( 0 );

    const isRightBarExpanded = useIsRightBarExpanded();
    const isShowingAlerts = useShouldShowAlerts();

    const handleButtonClick = ( level: AllowedImpactLevel ) =>
    {
        setOpenRiskDetails( true );
        setRiskLevelDetail( pagesToShow.indexOf( level ) );
    };
    // @ts-ignore
    const renderRiskLevelButton = ( level: AllowedImpactLevel ) => (
        <Tooltip key = {level} title = {impactLevelInfo[level].tooltip} placement = "left">
            <StyledLegendButton
                hexbackgroundcolor = {impactLevelInfo[level].color}
                onClick = {() => handleButtonClick( level )}
            >
                <ImpactIcon level = {level} width = {isMobile ? 20 : 24} blackAndWhite noPadding/>
            </StyledLegendButton>
        </Tooltip>
    );

    return (
        <React.Fragment>
            <LegendContainer isMobile = {isMobile} isRightBarExpanded = {isRightBarExpanded} isShowingAlerts = {isShowingAlerts} id = "step3">
                {pagesToShow.map( level => renderRiskLevelButton( level as AllowedImpactLevel ) )}
            </LegendContainer>
            <Dialog
                open = {openRiskDetails}
                PaperProps = {{
                    sx: {
                        minHeight: "80vh",
                        maxHeight: "80vh",
                    }
                }}
            >
                <DialogContent sx = {{ whiteSpace: "pre" }}>
                    <RiskLevelStepper level = {riskLevelDetail}/>
                </DialogContent>
                <DialogActions>
                    <Button onClick = {() => setOpenRiskDetails( false )} autoFocus>
                        {CLOSE}
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
};

export default Legend;
